/**
 * App configurations (public only)
 *
 * This config is consumed by `bin/build/sitemap.js` and
 * `src/app/scripts/app/constants.js`
 */
export default {
  // The Metropolis wallet
  METROPOLIS_WALLET: '0x745a2BC8CF1b8D53d3487d5a1F89eF92CbFdEf70',

  // Alchemy ID (https://docs.alchemy.com/)
  ALCHEMY_KEY: process.env.ALCHEMY_KEY || '',

  CONFIG: {
    // Testnet config
    TESTNET: {
      NETWORK: 'testnet',
      ALCHEMY_URL: 'https://polygon-mainnet.g.alchemy.com/v2',
      COLLECTION_URL: 'https://rarible.com/token/polygon',
      CONTRACTS: {
        AvatarCollection: {
          address: '0xd625d61A57b77970716f7206C528d68eE89cC20c',
          paperContractId: 'b889ea81-530f-434c-bfae-c8d9020df6a6',
          abiUrl: '/data/AvatarCollection.abi.mainnet.json'
        },
        Avatars: {
          address: '0x767d96A8DBa89a1D99f78F27060c0a2f466BEc32',
          abiUrl: '/data/Avatars.abi.mainnet.json'
        },
        AccessoryCollection: {
          address: '0xf24D9bEB540C2365bEB0C1Fa774F01C03fd5488c',
          paperContractId: 'e076f27c-ff9c-4bef-a73a-86d800247b3e',
          abiUrl: '/data/AccessoryCollection.abi.mainnet.json'
        },
        Accessories: {
          address: '0xc2B0A07ADA6f143e7679604914f5564e4F5D35b0',
          abiUrl: '/data/Accessories.abi.mainnet.json'
        }
      }
    },
    // Mainnet config
    MAINNET: {
      NETWORK: 'mainnet',
      ALCHEMY_URL: 'https://polygon-mainnet.g.alchemy.com/v2',
      COLLECTION_URL: 'https://rarible.com/token/polygon',
      CONTRACTS: {
        AvatarCollection: {
          address: '0xd625d61A57b77970716f7206C528d68eE89cC20c',
          paperContractId: 'b889ea81-530f-434c-bfae-c8d9020df6a6',
          abiUrl: '/data/AvatarCollection.abi.mainnet.json'
        },
        Avatars: {
          address: '0x767d96A8DBa89a1D99f78F27060c0a2f466BEc32',
          abiUrl: '/data/Avatars.abi.mainnet.json'
        },
        AccessoryCollection: {
          address: '0xf24D9bEB540C2365bEB0C1Fa774F01C03fd5488c',
          paperContractId: 'e076f27c-ff9c-4bef-a73a-86d800247b3e',
          abiUrl: '/data/AccessoryCollection.abi.mainnet.json'
        },
        Accessories: {
          address: '0xc2B0A07ADA6f143e7679604914f5564e4F5D35b0',
          abiUrl: '/data/Accessories.abi.mainnet.json'
        }
      }
    }
  },

  // The maximum number of items allowed in the users marketplace cart
  MAX_CART: 20,

  // Paper Config
  PAPER_CLIENT_ID: '42d933b9-802a-4778-b40d-842c75e0ee73',

  // Thirdweb Pay Config
  THIRDWEB_CLIENT_ID: '3b62fbac09932a69eaf398ccbfc67b0d',

  // Wagmi Config
  WALLET_CONNECT_PROJECT_ID: '65b605400e4fd043c7468835d41d2f5f',

  // The `company_id` value
  API_ID: '7d7618f6-8dba-4e47-b887-13b37da34640',

  /**
   * Realm / Mongo configurations (deprecated - service removed)
   */
  REALM_ID: '',
  REALM_KEY: '',

  // The default sort by
  DEFAULT_SORT_BY: 'az',

  // The avatar layers (all possible)
  AVATAR_LAYERS: [
    'background',
    'back_prop',
    'base',
    'skin_mod',
    'clothing',
    'clothing_accessories',
    'neck_accessories',
    'face',
    'eyes',
    'face_mods',
    'mouth',
    'makeup',
    'nose',
    'facial_hair',
    'hats_hair',
    'headgear',
    'face_cyborg',
    'ears',
    'ear_accessories',
    'glasses',
    'hands',
    'fullbody'
  ],

  AVATAR_LAYERS_CONFIG: {
    background: {},
    back_prop: { geometry: 'back' },
    base: {},
    skin_mod: {},
    clothing: {},
    clothing_accessories: {},
    neck_accessories: { geometry: 'middle' },
    face: {},
    makeup: {},
    eyes: {},
    mouth: {},
    nose: {},
    face_mods: {},
    facial_hair: {},
    hats_hair: {},
    headgear: {},
    face_cyborg: {},
    ears: {},
    ear_accessories: {},
    glasses: {},
    hands: { geometry: 'front' },
    fullbody: {}
  },

  // All categories (differs from layers in that "base" is composite of face & body)
  AVATAR_ALL_CATEGORIES: [
    'base',
    'eyes',
    'ears',
    'nose',
    'mouth',
    'hats_hair',
    'headgear',
    'clothing',
    'clothing_accessories',
    'fullbody',
    'glasses',
    'face_mods',
    'skin_mod',
    'makeup',
    'ear_accessories',
    'hands',
    'neck_accessories',
    'back_prop',
    'face_cyborg',
    'facial_hair',
    'background'
  ],

  AVATAR_BASE_LAYERS: ['face', 'base', 'ears', 'eyes', 'nose', 'mouth'],

  AVATAR_BASE_CATEGORIES: [
    'base',
    'ears',
    'eyes',
    'nose',
    'mouth',
    'background'
  ],

  // Used to render product category ordering
  AVATAR_PRODUCT_CATEGORIES: [
    'hats_hair',
    'headgear',
    'clothing',
    'clothing_accessories',
    'fullbody',
    'glasses',
    'face_mods',
    'makeup',
    'skin_mod',
    'ear_accessories',
    'hands',
    'neck_accessories',
    'back_prop',
    'face_cyborg',
    'facial_hair',
    'background'
  ]
}
